package com.karyadina.service

import com.karyadina.model.*

/**
 * Storage for Task Tracker data
 */
class TaskStorage(
    private val storage: KeyValueStorage = AppStorage.get()
) {
    companion object {
        private const val KEY_TASKS = "tasks"
        private const val KEY_CATEGORIES = "task_categories"
    }
    
    fun saveTasks(tasks: List<Task>) {
        storage.saveJson(KEY_TASKS, tasks)
    }
    
    fun loadTasks(): List<Task> {
        return storage.loadJson<List<Task>>(KEY_TASKS) ?: emptyList()
    }
    
    fun saveCategories(categories: List<String>) {
        storage.saveJson(KEY_CATEGORIES, categories)
    }
    
    fun loadCategories(): List<String> {
        return storage.loadJson<List<String>>(KEY_CATEGORIES) ?: emptyList()
    }
}

/**
 * Storage for Study Planner data
 */
class StudyPlannerStorage(
    private val storage: KeyValueStorage = AppStorage.get()
) {
    companion object {
        private const val KEY_SESSIONS = "study_sessions"
        private const val KEY_SUBJECTS = "study_subjects"
    }
    
    fun saveSessions(sessions: List<StudySession>) {
        storage.saveJson(KEY_SESSIONS, sessions)
    }
    
    fun loadSessions(): List<StudySession> {
        return storage.loadJson<List<StudySession>>(KEY_SESSIONS) ?: emptyList()
    }
    
    fun saveSubjects(subjects: List<Subject>) {
        storage.saveJson(KEY_SUBJECTS, subjects)
    }
    
    fun loadSubjects(): List<Subject> {
        return storage.loadJson<List<Subject>>(KEY_SUBJECTS) ?: emptyList()
    }
}

/**
 * Storage for Quick Notes data
 */
class QuickNotesStorage(
    private val storage: KeyValueStorage = AppStorage.get()
) {
    companion object {
        private const val KEY_NOTES = "quick_notes"
    }
    
    fun saveNotes(notes: List<QuickNote>) {
        storage.saveJson(KEY_NOTES, notes)
    }
    
    fun loadNotes(): List<QuickNote> {
        return storage.loadJson<List<QuickNote>>(KEY_NOTES) ?: emptyList()
    }
}
